import React from 'react';
import './Player.css';
import Visualizer from './Visualizer/Visualizer';
import { useTranslation } from 'react-i18next';

function importAll(r) { let images = {}; r.keys().forEach((item) => { images[item.replace('./', '')] = r(item); }); return images; }
const images = importAll(require.context('../assets/images', false, /\.(png|jpe?g|svg)$/));

function Player({ 
  currentSong, isPlaying, togglePlayPause, skipForward, skipBackward, 
  progressInfo, onSeekStart, progressBarRef, seekForward10, seekBackward10, playbackRate, 
  changePlaybackRate, repeatMode, changeRepeatMode, isShuffled, toggleShuffle,
  volume, onVolumeChange, analyser 
}) {
  const { i18n } = useTranslation();
  const formatTime = (time) => { if (isNaN(time)) return '0:00'; const minutes = Math.floor(time / 60); const seconds = Math.floor(time % 60); return `${minutes}:${seconds.toString().padStart(2, '0')}`; };
  const getRepeatIcon = () => { if (repeatMode === 'one') return 'fas fa-infinity'; return 'fas fa-retweet'; };
  const getVolumeIcon = () => { if (volume === 0) return 'fas fa-volume-mute'; if (volume < 0.5) return 'fas fa-volume-down'; return 'fas fa-volume-up'; };
  const [lastVolume, setLastVolume] = React.useState(volume);
  const toggleMute = () => { if (volume > 0) { setLastVolume(volume); onVolumeChange(0); } else { onVolumeChange(lastVolume); } };

  return (
    <div className="player-container">
      <div className="current-song">
        <img src={images[currentSong.imageSrc]} alt={currentSong.title[i18n.language]} className="album-art" />
        <div className="song-info">
          <span className="player-song-title">{currentSong.title[i18n.language]}</span>
          <span className="player-song-artist">{currentSong.artist[i18n.language]}</span>
        </div>
      </div>
      <div className="player-controls">
        <div className="control-buttons">
          <button className={`control-button extra-control ${isShuffled ? 'active' : ''}`} onClick={toggleShuffle}><i className="fas fa-random"></i></button>
          <button className="control-button" onClick={skipBackward}><i className="fas fa-step-backward"></i></button>
          <button className="control-button extra-control" onClick={seekBackward10}><i className="fas fa-undo-alt"></i></button>
          
          {/* NEW: Wrapper for the play button and visualizer */}
          <div className="play-button-wrapper">
            <button className="control-button play-pause-btn" onClick={togglePlayPause}><i className={isPlaying ? "fas fa-pause" : "fas fa-play"}></i></button>
            {analyser && <Visualizer analyser={analyser} />}
          </div>

          <button className="control-button extra-control" onClick={seekForward10}><i className="fas fa-redo-alt"></i></button>
          <button className="control-button" onClick={skipForward}><i className="fas fa-step-forward"></i></button>
          <button className={`control-button extra-control repeat-button ${repeatMode !== 'none' ? 'active' : ''}`} onClick={changeRepeatMode}>
            <div className="icon-wrapper"><i className={getRepeatIcon()}></i>{repeatMode === 'one' && <span className="repeat-one-indicator">1</span>}</div>
          </button>
        </div>
        <div className="progress-bar-container">
          <span className="time-display current-time">{formatTime(progressInfo.currentTime)}</span>
          <div 
            className="progress-bar" 
            ref={progressBarRef}
            onMouseDown={onSeekStart}
            onTouchStart={onSeekStart}
          >
            <div className="progress-bar-fill" style={{ width: `${(progressInfo.currentTime / progressInfo.duration) * 100 || 0}%` }}></div>
          </div>
          <span className="time-display total-time">{formatTime(progressInfo.duration)}</span>
        </div>
      </div>
      <div className="extra-controls">
        <button className="control-button playback-speed-btn" onClick={changePlaybackRate}>{playbackRate}x</button>
        <div className="volume-control-container">
          <button className="control-button" onClick={toggleMute}><i className={getVolumeIcon()}></i></button>
          <input type="range" min="0" max="1" step="0.01" value={volume} className="volume-slider" onChange={(e) => onVolumeChange(parseFloat(e.target.value))} />
        </div>
      </div>
    </div>
  );
}

export default Player;